import {createReducer, on} from '@ngrx/store';
import { ToggleFeatureActions } from './toggle-feature.actions';

export const toggleFeatureFeatureKey = 'Toggle Feature';

export type ToggleFeatureItem = {display: boolean, label: string};

export interface FeatureState {
    displayNonImplementedMenus: boolean;
    displayDevelopmentItems?: boolean;
}
 

export const initialFeatureState: FeatureState = {
    displayNonImplementedMenus: false,
    displayDevelopmentItems: false,
};

export const toggleFeatureReducer = createReducer<FeatureState>(
    initialFeatureState,
    on(
        ToggleFeatureActions.updateAllItems,
        (state, { checked }): FeatureState => {
            return ({
                ...state, 
                displayNonImplementedMenus: checked
            })
        }
    ),
    on(
        ToggleFeatureActions.updateDevelopmentItems,
        (state, { checked }): FeatureState => {
            return  ({
                ...state, 
                displayDevelopmentItems: checked
            })
        }
    ),
);
